module.exports = __webpack_public_path__ + "img/bul_device_pc_on.4076e251.svg";